import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NextStatusSelectComponent } from './next-status-select.component';
import { NextStatusSelectService } from './next-status-select.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [NextStatusSelectComponent],
  exports: [NextStatusSelectComponent],
  providers: [NextStatusSelectService]
})
export class NextStatusSelectModule { }



// WEBPACK FOOTER //
// ./src/app/utils/next-status-select/next-status-select.module.ts